import ChallengesAPI from "@/services/api/challenges"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const useEditChallenge = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: ChallengesAPI.editChallenge,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userChallenges"] })
    },
  })
  return mutation
}

export default useEditChallenge
